import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, query, where, getDocs } from 'firebase/firestore'

export default class Users extends BaseModel {
  constructor() {
    super(collection(db, 'users'))
  }

  async getByEmail(email: string) {
    const snap = await getDocs(query(this.baseQuery, where('email', '==', email)))
    const data = snap.docs.map((d) => d.data())

    return {
      data,
      ok: data.length > 0,
    }
  }

  async getAllClients() {
    const snap = await getDocs(query(this.baseQuery, where('type', '==', 'client')))
    const data = snap.docs.map((d) => d.data())

    return data
  }
}
